/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import * as types from 'constants/ActionTypes';
import { uniq } from 'utils/ObjectUtils';

/**
 * @typedef {{
 *   data: Record<string, import("modules/offers/types").Variant>,
 *   apiError: string,
 *   isFetching: boolean,
 *   selectedVariantCode: string,
 * }} VariantReducer
 */

const initialState = {
  data: {},
  apiError: null,
  isFetching: false,
  selectedVariantCode: '',
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.FETCH_VARIANT_REQUEST:
    case types.FETCH_VARIANT_MUTEX_REQUEST:
      if (!action.meta?.silent) {
        draft.isFetching = true;
      }
      draft.apiError = null;
      break;

    case types.FETCH_VARIANT_SUCCESS:
      draft.isFetching = false;
      draft.data[action.variantCode] = action.variant;
      draft.selectedVariantCode = action.variantCode;
      break;

    case types.FETCH_VARIANT_MUTEX_SUCCESS: {
      draft.isFetching = false;

      const variant = draft.data[action.meta.variantCode];
      Object.entries(action.payload.exclusions ?? {}).forEach(([featureCode, exclusion]) => {
        const category = variant.category?.find(({ feature }) => feature?.find(({ code }) => code === featureCode));
        if (category) {
          const feature = category.feature.find(({ code }) => code === featureCode);
          feature.exclusion = uniq([...(feature.exclusion ?? []), ...exclusion]);
        }
      });

      break;
    }
    case types.FETCH_VARIANT_FAILURE:
    case types.FETCH_VARIANT_MUTEX_FAILURE:
      draft.isFetching = false;
      draft.apiError = action.payload ?? action.error;
      break;

    case types.SET_CATEGORY_AS_SEEN: {
      draft.data[draft.selectedVariantCode] = {
        ...draft.data[draft.selectedVariantCode],
        category: draft.data[draft.selectedVariantCode].category.map(category => ({
          ...category,
          seen: category.code === action.code ? true : category.seen,
        })),
      };
      break;
    }

    case types.RESET_NEW_OFFER:
      draft.apiError = null;
      break;

    case types.CLEAN_MODEL_FILTER:
    case types.CLEAN_VARIANT: {
      if (draft.data[draft.selectedVariantCode]) {
        draft.data[draft.selectedVariantCode] = {};
      }
      draft.selectedVariantCode = '';
      break;
    }

    default:
  }
}, initialState);
export default reducer;
